import { Button } from '../ui';
interface InsightCardProps {
  title: string;
  impact: 'high' | 'medium' | 'low';
  confidence: number;
  evidence: string;
  actions?: string[];
  category?: string;
}

const impactColors: Record<string, string> = {
  high: 'border-l-red-500',
  medium: 'border-l-yellow-500',
  low: 'border-l-blue-500',
};

export function InsightCard({ title, impact, confidence, evidence, actions, category }: InsightCardProps) {
  return (
    <div class={`bg-gray-800 rounded-xl border border-gray-700 border-l-4 ${impactColors[impact] || impactColors.low} p-5 hover:bg-gray-750 transition-colors`}>
      <div class="flex items-start justify-between mb-3">
        <div>
          {category && <span class="text-xs text-indigo-400 font-medium uppercase tracking-wider">{category}</span>}
          <h3 class="text-white font-semibold mt-1">{title}</h3>
        </div>
        <div class="flex items-center gap-2 shrink-0">
          <span class={`text-xs px-2 py-0.5 rounded-full font-medium ${impact === 'high' ? 'bg-red-500/20 text-red-400' : impact === 'medium' ? 'bg-yellow-500/20 text-yellow-400' : 'bg-blue-500/20 text-blue-400'}`}>
            {impact === 'high' ? 'Alto' : impact === 'medium' ? 'Médio' : 'Baixo'}
          </span>
          <span class="text-xs text-gray-400">{Math.round(confidence * 100)}% confiança</span>
        </div>
      </div>
      <p class="text-sm text-gray-300 mb-3">{evidence}</p>
      {actions && actions.length > 0 && (
        <div class="flex flex-wrap gap-2">
          {actions.map((a, i) => (
            <Button variant="ghost" key={i} class="text-xs px-3 py-1.5 bg-indigo-600/20 text-indigo-300 rounded-lg hover:bg-indigo-600/30 transition-colors border border-indigo-600/30">
              {a}
            </Button>
          ))}
        </div>
      )}
    </div>
  );
}
